import setIncludeDeletedGuestlists from './set-included-deleted-guestlists';

export default {
    setIncludeDeletedGuestlists
}



// WEBPACK FOOTER //
// ./src/app/store/rsvps/mutations/index.js